import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=43ae15e6&scoped=true"
import script from "./DiscoverPage.vue?vue&type=script&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae15e6",
  null
  
)

export default component.exports